import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import AppConstants from './Constants/AppConstants';

Sentry.init({
  dsn: 'https://72a21e14b8904725bfe187d316524b52@o396771.ingest.sentry.io/5284101',
  tracesSampleRate: 0.0,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
